import React from "react";

class Error extends React.Component {
  render() {
    return (
      <>
        <div className="app-login">
          <div className="container-fluid">
            <div className="">
              <div className="">
                <div className="row align-items-center">
                  <div className="col no-pd">
                    <div className="app-login__banner">
                      <div className="app-login__banner__content">
                        <div className="row justify-content-center">
                          <div className="">
                            <h1 className="app-login__banner__content__title">
                              Houve um erro
                            </h1>
                            <h2
                              className="app-login__banner__content__sub-title"
                              style={{ width: "auto" }}
                            >
                              Tente novamente fazer o login mais tarde na tela
                              inicial
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Error;
